import React from "react"
import TitleStyled from "../components/styles/titleStyles"
import ManagingStyled from "../components/styles/ManagingStyles"
import uuid from "react-uuid"
import ManagingItem from "./managingItem"

const Managing = props => {
  const heading = props.data.settings.heading
  const person = props.data.settings.person

  return (
    <section className="managing">
      <ManagingStyled>
        <div className="container">
          <TitleStyled
            textAlign="center"
            linePosition="center"
            color="#000"
            lineColor="#000"
          >
            <h2>{heading}</h2>
          </TitleStyled>
        </div>
        <div className="container managing__container">
          {person.map((item, index) => (
            <ManagingItem hey={uuid()} data={item} />
          ))}
        </div>
      </ManagingStyled>
    </section>
  )
}

export default Managing
